import React from 'react';
import {Divider} from "@heroui/react";

const TermsConditionsPage = () => {
  return (
    <div className="container" id="terms-conditions">
      <h3 className='title'>EMS ADMIN TERMS AND CONDITIONS FOR USE OF THIS INTERNET SITE</h3>
      <Divider className='mt-0 mb-3'/>
      <div className='content'>
        <p>
          This agreement contains the terms and conditions for the use of the EMS Admin Internet Site. As used in this Agreement:<br/>
          (i) "we", "us", or "our" refers to EMS Admin;<br/>
          (ii) "you" or "your" refers to the individual or entity using the "Internet Site;"<br/>
          (iii) "Internet Site" refers to all viewable pages (including page headers, custom graphics, button icons, links, and text), 
          underlying program code, and accompanying services and documentation of this site; and<br/>
          (iv) "Partner" refers to a third-party entity with whom EMS Admin has created a version of this Internet Site or whom EMS Admin
          has authorized to link to this Internet Site or with whom EMS Admin has a joint marketing relationship. By accessing, browsing, and/or using this Internet Site,
          you acknowledge that you have read, understood, and agreed to be bound by these terms and conditions and comply with all applicable laws and regulations, including 
          U.S. laws and regulations.
        </p>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>1.Licensee of Use</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              We grant to you a limited, non-exclusive, non-transferable, revocable license to use the Internet Site only for managing your purchasing process, including viewing, 
              requesting, approving and ordering products for yourself or on behalf of your company. As a licensee of the Internet Site you may not rent, lease, grant a security interest in, 
              or otherwise transfer any rights you have in the use of this Internet Site. You further are not authorized to resell the purchase management and processing services of this Internet Site.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>2.Pricing</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              In the event that a product is listed at an incorrect price due to a typographical error or error in pricing information received from our suppliers, EMS Admin shall have
              the right to refuse or cancel any orders placed for product listed at the incorrect price. EMS Admin shall inform you via fax, mail or email when orders are refused due to
              errors.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>3.Purchasing Conditions</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              By placing an order with EMS Admin, you agree to be bound by the terms and conditions of this Agreement and the policies of EMS Admin in effect at the time of each order.
              You declare that you own the rights to the board and files delivered to EMS Admin and/or its Partners. You also agree that any duplicate or re-orders submitted are exactly
              the same as previous orders or new tooling costs will incur. Each of your orders is subject to acceptance by us. We reserve the right to accept or decline any order for any or no reason. 
              Further, EMS Admin and its Partners shall have the right to cancel for any reason any orders placed and accepted by EMS Admin and its Partners.
            </p>
            <p>
              Risk of any loss or damage to products you order from us shall transfer to you upon delivery of such products to you. Title to these items shall pass to you only upon full payment of the total 
              price for such items. Until such full payment, you hereby grant us a purchase money security interest in such items ordered from us, and further agree to cooperate and assist us in the perfection 
              of such interest.
            </p>
            <p>
              The acceptance by EMS Admin and its Partners of any purchase order placed by you is expressly made conditional on your agreement to the terms set forth herein, and not those in your purchase order.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>4.No Warranty/Disclaimer</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              EMS Admin and its partners do not warrant that your use of the Internet site will be uninterrupted, that messages or requests will be delivered, or that the operation of the Internet site will be
              error-free or secure. In addition, the security mechanisms implemented by EMS Admin and its partners may have inherent limitations, and you must determine yourself that the Internet site sufficiently
              meets your requirements. EMS Admin and its partners are not responsible for your data whether residing on our or your servers.
            </p>
            <p>
              You shall be responsible for all use of your account and maintaining the confidentiality of your password and information. We discourage your sharing of your password and account number with anyone; any such 
              sharing shall be entirely at your own risk. Accordingly, you should select a unique, non-obvious password and change your passwords often.
            </p>
            <p>
              The EMS Admin Internet site and its contents are provided "as is" and EMS Admin and its partners make no representations or warranties of any kind with respect to this site, its contents or any product.
              EMS Admin and its Partners hereby expressly disclaim all warranties, either express or implied, of merchantability, fitness for a particular purpose, or non-infringement. This disclaimer by EMS Admin
              and its Partners in no way affects the manufacturer's warranty, if any, which shall be passed onto you. EMS Admin, its Partners, its suppliers and resellers shall not be liable for any direct, indirect,
              special, incidental or consequential damages (including, but not limited to, damages for lost revenue, lost profits, business interruption, lost information or data, computer interruption, and the like) or
              cost of procurement of substitute goods or services arising from or related to the use of products or the use or inability to use this Internet site, even if EMS Admin and/or its Partners shall have been
              informed of the possibility of such damages, or for any claim by any other party. EMS Admin and its Partners do not represent or warrant that the information provided on this Internet site is accurate,
              complete or current. These limitations shall survive any termination of this agreement.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>5.Title</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              All title, ownership rights, and intellectual property rights in the Internet Site shall remain in EMS Admin, its Partners and/or its suppliers. Copyright laws and treaties protect this Internet Site,
              and you shall not remove any proprietary notices or labels on the Internet Site. Through the use of this Internet Site no intellectual property rights will transfer to you.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>6.Copyright</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              This Internet Site is Copyright (c) 2004 EMS Admin, all rights reserved. Permission is hereby granted to print in hard copy portions of this Internet Site for the sole purposes of placing or approving
              a request or order using this Internet Site or archiving business records. Any other use of any portion of this site, including reproduction for purposes other than those specified herein, modification, 
              distribution, or publication, are expressly prohibited without the prior written permission of EMS Admin.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>7.Trademarks</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              EMS Admin and the EMS Admin logo are trademarks of EMS Admin. All other trademarks, service marks, product names and company names or company logos cited herein are the property of their respective owners.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>8.Upgrades</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              EMS Admin and the its Partners reserve the right to update and upgrade the Internet Site at our sole discretion without notice to you, including but not limited to, changing functionality, user interface, procedures,
              documentation, or any of the terms and conditions of this Agreement. EMS Admin further reserves the right to modify any of the terms and conditions contained herein and in the policies by posting them on the Internet Site.
              If any update, upgrade or modification is unacceptable to you, your only recourse is to discontinue your use of the Internet site. Your continued use of the Internet site following any change in our site or posting of a new 
              agreement on our site will constitute a binding acceptance of the change.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>9.Prohibition Against Modification</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              Under the foregoing license, you are prohibited from modifying, translating, recompiling, disassembling or reverse engineering or otherwise attempting to derive the source code for the operation of the Internet Site or creating derivative 
              EMS Admin based on the Internet Site or parts of the Internet Site. For purposes of this Agreement, "reverse engineering" shall mean the examination or analysis of the Internet Site software to determine its source code, structure,
              organization, internal design, algorithms or encryption devices.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>10.Termination</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              This license will terminate automatically upon our notice to you if you fail to comply with the terms and conditions described herein. EMS Admin has the right to terminate the license of any user at any time for any or no reason.
              Such termination may be based solely on the discretion of EMS Admin and/or its Partners.
            </p>
          </div>
        </div>
        <div className='panel py-3 pe-5'>
          <div className='panel-title'>
            <h4>11.Other Disclaimers</h4>
          </div>
          <div className='panel-content px-3'>
            <p>
              EMS Admin and its Partners will not be responsible or liable to you for any delay or failure to perform under this Agreement if such delay or failure results from fire, explosion, labor dispute, earthquake, casualty or accident,
              lack or failure of transportation facilities and/or services, lack or failure of telecommunications facilities and/or services including Internet services, epidemic, flood, drought, or by reason of war, revolution, civil commotion, 
              blockade or embargo, act of God, any inability to obtain any requisite license, permit or authorization, or by reason of any law, proclamation, regulation, ordinance, demand or requirement of any government or by reason of any other 
              cause whatsoever, whether similar or dissimilar to those enumerated, beyond the reasonable control of EMS Admin and its Partners.
            </p>
            <p>
              You may not export any goods purchased hereunder without first obtaining from the United States government all required export licenses or other permission. Manufacturers' warranties for exported goods vary and may be null and void if exported.
            </p>
            <p>
              This Agreement represents the complete agreement concerning this license and may be amended only by a written amendment executed by both parties.
            </p>
            <p>
              If any provision of this Agreement is held to be unenforceable, such provision shall be reformed only to the extent necessary to make it enforceable.
            </p>
            <p>
              You represent and warrant that, as the individual electronically agreeing to the terms of this Agreement, you are authorized and empowered to agree to this Agreement on behalf of yourself and any organization that you purport to represent.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsConditionsPage;